<div class="main container">
  @if (edTreatmentResponse) {
    <app-card class="my-4" data-qa-id="ED Treatment Card" contentClasses="p-5" headerClasses="is-hidden">
      <div class="columns">
        <div class="column has-text-centered">
          <h2
            class="ed-treatment-title mt-3 has-text-weight-bold has-text-black"
            [innerHTML]="edTreatmentResponse.title"
          ></h2>
        </div>
      </div>

      @if (edTreatmentResponse.subtitle) {
        <div class="columns">
          <div class="column has-text-centered">
            <p class="ed-treatment-subtitle" [innerHTML]="edTreatmentResponse.subtitle"></p>
          </div>
        </div>
      }

      <div class="columns is-vcentered mt-3">
        <div class="column px-5-desktop is-6 has-text-centered">
          @if (edTreatmentResponse.imageUrl | imageFallback: 'assets/img/ed-treatment.png' | async; as imageUrl) {
            <img
              class="ed-treatment-img"
              priority
              [ngSrc]="imageUrl"
              width="352"
              height="347"
              alt="Illustration representing ED treatment"
            />
          }
        </div>
        <div class="column px-5-desktop is-6">
          <h4 class="is-size-5 has-text-weight-bold has-text-black mb-3">{{ edTreatmentResponse.content.header }}</h4>
          <p class="ed-treatment-description mb-5">{{ edTreatmentResponse.content.description }}</p>

          @for (section of edTreatmentResponse.content.sections; track section.title.text; let last = $last) {
            <div class="ed-treatment-section">
              <div class="is-flex is-align-items-center mb-2">
                @if (section.title.icon) {
                  <span class="icon has-text-primary mr-2">
                    <i [class]="section.title.icon"></i>
                  </span>
                }
                <h5 class="ed-treatment-section-title has-text-weight-bold has-text-primary">
                  {{ section.title.text }}
                </h5>
              </div>
              <ul class="ed-treatment-list ml-5">
                @for (item of section.listItems; track item) {
                  <li [innerHTML]="item"></li>
                }
              </ul>
            </div>
            @if (!last) {
              <hr class="my-4" />
            }
          }
        </div>
      </div>

      @if (isExpandedContent) {
        <div class="columns is-multiline faq" data-qa-id="ED Treatment FAQ Section">
          <div class="column is-12 has-text-centered">
            <h4 class="is-size-5 has-text-weight-bold has-text-black">{{ edTreatmentResponse.faqContent.title }}</h4>
          </div>
          <div class="column is-offset-2 is-8">
            @for (faq of edTreatmentResponse.faqContent.faqs; track faq.question; let i = $index) {
              <div
                class="card is-clickable mt-3"
                (click)="toggleFaqItem(faq)"
                [attr.data-qa-id]="'ED Treatment FAQ Question ' + i"
                [class.is-active]="faq.isExpanded"
              >
                <header class="card-header has-text-weight-semibold">{{ faq.question }}</header>
                @if (faq.isExpanded) {
                  <div class="card-content" [attr.data-qa-id]="'ED Treatment FAQ Answer ' + i">
                    <p>{{ faq.answer }}</p>
                  </div>
                }
              </div>
            }
            <div class="column mt-5 pb-0 is-12 has-text-centered">
              <a
                class="is-clickable read-more-less-btn has-text-weight-bold"
                data-qa-id="ED Treatment Read Less Toggle"
                (click)="toggleContent()"
              >
                Read Less <i class="fa-solid fa-chevron-up ml-1"></i>
              </a>
            </div>
          </div>
        </div>
      } @else {
        <div class="columns">
          <div class="column is-12 has-text-centered py-3">
            <a
              class="is-clickable read-more-less-btn has-text-weight-bold"
              data-qa-id="ED Treatment Read More Toggle"
              (click)="toggleContent()"
            >
              Read More <i class="fa-solid fa-chevron-down ml-1"></i>
            </a>
          </div>
        </div>
      }

      <hr class="ed-treatment-divider" />

      <div class="ed-treatment-cta has-text-centered mb-4">
        <h4 class="is-size-4 mb-4 has-text-weight-bold has-text-black">{{ edTreatmentResponse.cta.question }}</h4>

        <div class="ed-treatment-cta-buttons">
          <button
            type="button"
            class="button has-text-weight-semibold ed-treatment-decline"
            data-qa-id="ED Treatment Decline Button"
            [disabled]="processing"
            (click)="navigateToNextPage()"
          >
            {{ edTreatmentResponse.cta.declineButton }}
          </button>
          @for (acceptButton of edTreatmentResponse.cta.acceptButtons; track acceptButton) {
            <button
              type="button"
              class="button has-text-white has-text-weight-semibold ed-treatment-add-to-order-button"
              [attr.data-qa-id]="'ED Treatment Accept Button ' + acceptButton"
              [disabled]="processing || rechargeAttempt"
              (click)="submit()"
            >
              {{ acceptButton }}<br />
              {{ edTreatmentResponse.price | currency: 'USD' : 'symbol-narrow' : '1.0-0' }}
            </button>
          }
        </div>
      </div>
    </app-card>

    @if (showPaymentInformation) {
      <app-payment-card-form
        #paymentCardForm
        class="is-block mt-4"
        [lineItems]="[upsellTestLineItem]"
        [enablePayLater]="false"
        (paymentsSelected)="onPaymentsSelected($event)"
      ></app-payment-card-form>
      <app-payment-submit-button
        class="is-block mt-4 mb-5"
        buttonText="Finish Placing My Order"
        [processing]="processing"
        [payments]="payments"
        [(submissionErrors)]="submissionErrors"
        (paymentSubmitted)="submit()"
      ></app-payment-submit-button>
    }
  }
</div>
